import { GET_DEBIT_ACCOUNT_SUCCESS } from 'stash/actions/api';

const harmonyBank = (state = {}, action) => {
	switch (action.type) {
		case GET_DEBIT_ACCOUNT_SUCCESS: {
			return {
				...state,
				debit_accounts: action.response.accounts,
			};
		}

		default:
			return state;
	}
};

export default harmonyBank;
